import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { platformApiFetch } from '../../api/client';

export const organizationsQueryKey = (q) => ['platform', 'organizations', q ?? ''];

export function useOrganizations(q) {
  const trimmed = q?.trim();
  const query = trimmed ? `?q=${encodeURIComponent(trimmed)}` : '';
  return useQuery({
    queryKey: organizationsQueryKey(trimmed),
    queryFn: () => platformApiFetch(`/api/platform/organizations${query}`),
  });
}

export function useOrganization(uuid) {
  return useQuery({
    queryKey: ['platform', 'organizations', uuid],
    queryFn: () => platformApiFetch(`/api/platform/organizations/${uuid}`),
    enabled: Boolean(uuid),
  });
}

export function useUpdateOrganization(uuid) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch(`/api/platform/organizations/${uuid}`, {
        method: 'PATCH',
        body,
        errorMessage: 'Failed to update organization',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platform', 'organizations'] });
    },
  });
}
